import React from 'react';
import { HStack, VStack, Avatar, Text, Button } from '@chakra-ui/react';

interface ChannelInfoProps {
  channelName: string;
  subscriberCount: number;
  avatarUrl?: string;
  isSubscribed: boolean;
  onSubscribe: () => void;
  isPublisher?: boolean;
  onEdit?: () => void;
}

const ChannelInfo: React.FC<ChannelInfoProps> = ({
  channelName,
  subscriberCount,
  avatarUrl,
  isSubscribed,
  onSubscribe,
  isPublisher = false,
  onEdit
}) => {
  const formatSubscriberCount = (count: number): string => {
    if (count >= 1000000) return `${(count / 1000000).toFixed(1)}M`;
    if (count >= 1000) return `${(count / 1000).toFixed(1)}k`;
    return count.toString();
  };

  return (
    <VStack
      position="absolute"
      bottom={180}
      left={4}
      right={{ base: "60px", md: "80px" }}
      zIndex={20}
      align="flex-start"
      spacing={3}
      maxW={{ base: "calc(100vw - 80px)", md: "calc(100vw - 160px)" }}
    >
      <HStack spacing={3} align="center" w="100%">
        <Avatar
          size="md"
          src={avatarUrl}
          name={channelName}
          bg="purple.500"
          color="white"
          fontWeight="bold"
        />
        
        <VStack align="flex-start" spacing={0} minW={0} flex="1">
          <Text
            color="white"
            fontSize="md"
            fontWeight="bold"
            noOfLines={1}
            maxW="150px"
            overflow="visible"
            whiteSpace="nowrap"
          >
            {channelName}
          </Text>
          <Text
            color="white"
            fontSize="sm"
            opacity={0.8}
            noOfLines={1}
          >
            {formatSubscriberCount(subscriberCount)} subscribers
          </Text>
        </VStack>
      </HStack>

      {isPublisher ? (
        <Button
          size="sm"
          colorScheme="blue"
          bg="blue.500"
          color="white"
          borderRadius="full"
          px={6}
          fontWeight="bold"
          _hover={{ bg: 'blue.600' }}
          _active={{ bg: 'blue.700' }}
          onClick={onEdit}
          alignSelf="flex-start"
        >
          Edit Short
        </Button>
      ) : (
        <Button
          size="sm"
          colorScheme="purple"
          bg="purple.500"
          color="white"
          borderRadius="full"
          px={6}
          fontWeight="bold"
          _hover={{ bg: 'purple.600' }}
          _active={{ bg: 'purple.700' }}
          onClick={onSubscribe}
          alignSelf="flex-start"
        >
          {isSubscribed ? 'Subscribed' : 'Subscribe'}
        </Button>
      )}
    </VStack>
  );
};

export default ChannelInfo;
